import { useMutation } from '@tanstack/react-query';
import type { CepLookup, CnpjLookup } from '@amai/contracts';
import { api } from './api';

/**
 * Preenchimento automático a partir do CNPJ e do CEP.
 *
 * Regra de ouro: só preenche campo VAZIO. O que o operador digitou vale mais
 * do que o que a Receita devolve — ele pode estar corrigindo justamente um
 * dado desatualizado na base pública.
 */

export function useCnpjLookup() {
  return useMutation({
    mutationFn: (document: string) => api.get<CnpjLookup>(`/lookup/cnpj/${document}`),
  });
}

export function useCepLookup() {
  return useMutation({
    mutationFn: (cep: string) => api.get<CepLookup>(`/lookup/cep/${cep}`),
  });
}

/** Devolve `next` só quando o campo atual está vazio. */
export function fillIfEmpty(current: string, next: string | null | undefined): string {
  if (current.trim() !== '') return current;
  return next ?? '';
}
